import { render, staticRenderFns } from "./ExaminationSchedulerHbh.vue?vue&type=template&id=1b422b3a&"
import script from "./ExaminationSchedulerHbh.vue?vue&type=script&lang=js&"
export * from "./ExaminationSchedulerHbh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports